import Slowparse from 'slowparse/src';
import SlowparseHTMLParser from 'slowparse/src/HTMLParser';

SlowparseHTMLParser.prototype.omittableCloseTagHtmlElements = [];

export default Slowparse;
